const HAS_SCHEME = /^[a-z][a-z0-9+.-]*:/i;
const SCHEME_ONLY = /^(?:ftp|https?):?\/?\/?$/i;
const VALID_URL = /^(ftp|http|https):\/\/[^ "]+$/i;

/** Add https:// when a website value has no scheme. Leaves existing schemes unchanged. */
export function ensureHttpsWebsite(value) {
    const trimmed = String(value ?? '').trim();
    if (!trimmed || trimmed === '-' || SCHEME_ONLY.test(trimmed) || HAS_SCHEME.test(trimmed)) {
        return trimmed;
    }
    return `https://${trimmed.replace(/^\/+/, '')}`;
}

/** Empty is allowed. A domain without a scheme is valid once https:// is assumed. */
export function isWebsiteUrl(value) {
    const trimmed = String(value ?? '').trim();
    if (!trimmed) return true;
    return VALID_URL.test(ensureHttpsWebsite(trimmed));
}
